import useMediaQuery from '@material-ui/core/useMediaQuery';
import {
  mobileDevice,
  defaultDevice,
} from '../constants/DeviceBreakPoints';

export const Mobile = ({
  children,
}) => {
  const isMatched = useMediaQuery(`(max-width:${mobileDevice}px)`);

  return isMatched ? children : null;
};

export const Default = ({
  children,
}) => {
  const isMatched = useMediaQuery(`(min-width:${defaultDevice}px)`);

  return isMatched ? children : null;
};

/**
* Material-UI breakpoints:
*    value         |0px     600px    960px    1280px   1920px
*    key           |xs      sm       md       lg       xl
*    screen width  |--------|--------|--------|--------|-------->
*    range         |   xs   |   sm   |   md   |   lg   |   xl
*/

/**
 * General breakpoints for Device:
 * 1. Extra small devices (phones, 600px and down)
 *    @media only screen and (max-width: 600px) {...}
 *
 * 2. Small devices (portrait tablets and large phones, 600px and up)
 *    @media only screen and (min-width: 600px) {...}
 *
 * 3. Medium devices (landscape tablets, 768px and up)
 *    @media only screen and (min-width: 768px) {...}
 *
 * 4. Large devices (laptops/desktops, 992px and up)
 *    @media only screen and (min-width: 992px) {...}
 *
 * 5. Extra large devices (large laptops and desktops, 1200px and up)
 *    @media only screen and (min-width: 1200px) {...}
 */
